export const ProjectAccessLevel = {
  None: 0,
  ReadOnly: 1,
  Worker: 2,
};
